export default "__VITE_ASSET__CtXlM_4M__"